import { render, staticRenderFns } from "./supplierReturnHistories.vue?vue&type=template&id=034808a1&scoped=true&"
import script from "./supplierReturnHistories.vue?vue&type=script&lang=js&"
export * from "./supplierReturnHistories.vue?vue&type=script&lang=js&"
import style0 from "./supplierReturnHistories.vue?vue&type=style&index=0&id=034808a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034808a1",
  null
  
)

component.options.__file = "supplierReturnHistories.vue"
export default component.exports